import { mapCollection } from '../../utils/collection.utils';
import { Cause } from '../cause';

export class CauseBuilder {
  static fromJson(json) {
    return (json)
      ? new Cause(
        json.code,
        json.description,
        json.imputable,
        json.isImputable,
      )
      : null;
  }

  static fromList(list) {
    return mapCollection(CauseBuilder.fromJson, list);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/cause.builder.ts